module.exports = __webpack_public_path__ + "img/NBL1North.206120f2.png";